import Cookies from 'js-cookie';
import FetchData from '../Components/ServerCall/FetchData';
import { ConnectionInfo } from '../Components/DbConnection/Data';
export async function getDbConnectionDetails(connectionId: string, worksapceId: string) {
  const res = await FetchData({
    requestType: 'withData',
    method: 'GET',
    url: `database-connection/${connectionId}?workspaceId=${worksapceId}`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${Cookies.get('authToken')}`,
    },
  });
  if (!res.status) {
    console.log('Error in getting db connection details', res.data);
    return {
      isError: true,
      message: (res.error ?? 'Failed to get db connection details') as string,
      data: null,
    };
  }
  return {
    isError: false,
    message: 'Db connection details fetched successfully',
    data: {
      ...res.data,
      keystore: null,
      truststore: null,
    } as ConnectionInfo,
  };
}
export async function testDBConnection(
  workspaceId: string,
  payload: ConnectionInfo,
  isForm = false,
) {
  let formData = new FormData();
  if (isForm) {
    formData.append('connectionName', payload.connectionName);
    formData.append('vendor', payload.vendor!);
    formData.append('host', payload.server);
    formData.append('port', payload.port.toString());
    formData.append('serviceName', payload.database);
    formData.append('keystorePassword', payload.keystorePassword);
    formData.append('truststorePassword', payload.truststorePassword);
    formData.append('username', payload.username);
    formData.append('password', payload.password);

    if (payload.keystore) {
      formData.append('keystore', payload.keystore as File);
    }

    if (payload.truststore) {
      // Check if a truststore is selected (assuming similar logic)
      formData.append('truststore', payload.truststore as File);
    }
  }
  const res = await FetchData({
    requestType: 'withData',
    method: 'POST',
    url: `${isForm ? 'testOracleConnection' : 'database-connection-test'}?workspaceId=${workspaceId}`,
    headers: {
      'Content-Type': isForm ? 'multipart/form-data' : 'application/json',
      Authorization: `Bearer ${Cookies.get('authToken')}`,
    },
    data: isForm ? formData : payload,
  });
  if (!res.status) {
    return {
      isError: true,
      message: (res.error ?? 'Failed to Test connection') as string,
      data: null,
    };
  }
  return {
    isError: false,
    message: 'Test connection successful',
    data: res.data /**type casting will be done after consulting with backend team
     */,
  };
}
export async function RegisterOrUpdateDBConnection(
  workspaceId: string,
  payload: ConnectionInfo,
  isForm = false,
  update = false,
  conectionId?: string,
) {
  if (isForm && update && !conectionId) {
    console.error('conectionId is required for form data');
    return {
      isError: true,
      message: 'DB connection not  found',
      data: null,
    };
  }
  let formData = new FormData();
  if (isForm) {
    formData.append('connectionName', payload.connectionName);
    formData.append('vendor', payload.vendor!);
    formData.append('host', payload.server);
    formData.append('port', payload.port.toString());
    formData.append('serviceName', payload.database);
    formData.append('keystorePassword', payload.keystorePassword);
    formData.append('truststorePassword', payload.truststorePassword);
    formData.append('username', payload.username);
    formData.append('password', payload.password);

    if (payload.keystore) {
      formData.append('keystore', payload.keystore as File);
    }

    if (payload.truststore) {
      formData.append('truststore', payload.truststore as File);
    }
  }

  const url = isForm
    ? update
      ? `updateOracleConnection/${conectionId}`
      : 'createOracleConnection'
    : update
      ? `database-connection/${conectionId}`
      : 'database-connection';

  const res = await FetchData({
    requestType: 'withData',
    method: update ? 'PUT' : 'POST',
    url: `${url}?workspaceId=${workspaceId}`,
    headers: {
      'Content-Type': isForm ? 'multipart/form-data' : 'application/json',
      Authorization: `Bearer ${Cookies.get('authToken')}`,
    },
    data: isForm ? formData : payload,
  });
  if (!res.status) {
    return {
      isError: true,
      message: res.error ?? 'Failed to register connection',
      data: null,
    };
  }
  return {
    isError: false,
    message: `Db connection ${update ? 'updated' : 'registered'} successfully`,
    data: res.data /**type casting will be done after consulting with backend team
     */,
  };
}

export async function getAllDatabaseConnectionsInWorkspace(workspaceId: string) {
  const res = await FetchData({
    requestType: 'withData',
    method: 'GET',
    url: `database-connection?workspaceId=${workspaceId}`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${Cookies.get('authToken')}`,
    },
  });
  if (!res.status) {
    return {
      isError: true,
      message: (res.error ?? 'Failed to get database connections') as string,
      data: null,
    };
  }
  return {
    isError: false,
    message: 'Database connections fetched successfully',
    data: res.data,
  };
}

export async function getDatabaseConnectionTree() {
  const res = await FetchData({
    requestType: 'withData',
    method: 'GET',
    url: `dbConnection/tree`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${Cookies.get('authToken')}`,
    },
  });
  if (!res.status) {
    return {
      isError: true,
      message: (res.error ?? 'Failed to get database connection tree') as string,
      data: null,
    };
  }
  return {
    isError: false,
    message: 'Database connection tree fetched successfully',
    data: res.data,
  };
}

export async function getMetaDataDatabase(databaseConnectionId: string, workspaceId: string) {
  const res = await FetchData({
    requestType: 'noData',
    method: 'GET',
    url: `metadata-databases/${databaseConnectionId}?workspaceId=${workspaceId}`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${Cookies.get('authToken')}`,
    },
  });
  if (!res.status) {
    return {
      isError: true,
      message: (res.error ?? 'Failed to get metadata database') as string,
      data: null,
    };
  }
  return {
    isError: false,
    message: 'Metadata database fetched successfully',
    data: res.data,
  };
}

export async function getMetaDataSchema(
  databaseConnectionId: string,
  databaseName: string,
  workspaceId: string,
) {
  const res = await FetchData({
    requestType: 'noData',
    method: 'GET',
    url: `metadata-schemas/${databaseConnectionId}?database=${databaseName}&workspaceId=${workspaceId}`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${Cookies.get('authToken')}`,
    },
  });
  if (!res.status) {
    return {
      isError: true,
      message: (res.error ?? 'Failed to get metadata schema') as string,
      data: null,
    };
  }
  return {
    isError: false,
    message: 'Metadata schema fetched successfully',
    data: res.data,
  };
}
